import { ICONS, Icon } from 'components/Icons';
import classNames from 'classnames';
import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions';
import TopicReadingArticle from './TopicReadingArticle';
import { canViewSyllabusAndSuggestedReadings } from '../../helpers/helpers';
import './TopicSuggestedReadings.scss';

function TopicSuggestedReadings({
  selectedTopic,
  selectedCourse,
  suggestedReadings = [],
  selectedArticles = [],
  onSelectArticle,
  showCheckbox = false,
  showBanner = true,
  showTitle = true,
  actions,
  topic,
  course,
  user,
  syllabus,
  syllabusRow,
}) {
  const [acceptedReadings, setAcceptedReadings] = useState([]);
  const [rejectedReadings, setRejectedReadings] = useState([]);

  useEffect(() => {
    const preApprovedReadings = (suggestedReadings || [])
      .filter((reading) => reading.status === 'approved')
      .map((reading) => reading._id);

    setAcceptedReadings(preApprovedReadings);

    const preRejecteddReadings = (suggestedReadings || [])
      .filter((reading) => reading.status === 'rejected')
      .map((reading) => reading._id);

    setRejectedReadings(preRejecteddReadings);
  }, [suggestedReadings]);

  const handleAccept = useCallback(
    async (readingId) => {
      setAcceptedReadings((prev) => [...prev, readingId]);

      if (syllabusRow) {
        try {
          await actions.updateSyllabusReadingStatus(
            selectedCourse,
            syllabusRow._id,
            readingId,
            'approved',
          );
        } catch (error) {
          console.error('Error updating reading status:', error);
        }
      }
    },
    [syllabusRow, selectedCourse, actions],
  );

  const handleReject = useCallback(
    async (readingId) => {
      setRejectedReadings((prev) => [...prev, readingId]);

      if (syllabusRow) {
        try {
          await actions.updateSyllabusReadingStatus(
            selectedCourse,
            syllabusRow._id,
            readingId,
            'rejected',
          );
        } catch (error) {
          console.error('Error updating reading status:', error);
        }
      }
    },
    [syllabusRow, selectedCourse, actions],
  );

  const handleDiscard = useCallback(async () => {
    const allReadingIds = suggestedReadings.map((r) => r._id);
    setRejectedReadings(allReadingIds);
    setAcceptedReadings([]);

    if (syllabusRow) {
      try {
        await actions.updateSyllabusRowStatus(
          selectedCourse,
          syllabusRow._id,
          'rejected',
        );
      } catch (error) {
        console.error('Error updating row status:', error);
      }
    }
  }, [suggestedReadings, syllabusRow, selectedCourse, actions]);

  const handlePublish = useCallback(async () => {
    if (syllabusRow) {
      try {
        await actions.updateSyllabusRowStatus(
          selectedCourse,
          syllabusRow._id,
          'published',
        );
        await actions.getTopicReadings(selectedCourse, selectedTopic);
        console.log('Publishing accepted readings:', acceptedReadings);
      } catch (error) {
        console.error('Error publishing readings:', error);
      }
    }
  }, [acceptedReadings, syllabusRow, selectedCourse, actions, selectedTopic]);

  const filteredSuggestedReadings = suggestedReadings.filter(
    (reading) => !rejectedReadings.includes(reading._id),
  );

  const acceptedList = filteredSuggestedReadings.filter((reading) =>
    acceptedReadings.includes(reading._id),
  );

  const pendingList = filteredSuggestedReadings.filter(
    (reading) => !acceptedReadings.includes(reading._id),
  );

  const hasAcceptedReadings = acceptedReadings.length > 0;
  const hasSuggestedReadings = filteredSuggestedReadings.length > 0;
  const canViewSyllabusContent = canViewSyllabusAndSuggestedReadings(
    course,
    user,
  );

  // const weekStartDate = syllabusRow?.date
  //   ? moment(syllabusRow.date).format('MMMM D, YYYY')
  //   : null;

  if (!canViewSyllabusContent) {
    return null;
  }

  // if ((syllabusRow?.status || '').toLowerCase() !== 'draft') {
  //   return null;
  // }

  if (!hasSuggestedReadings) {
    return (
      <div className="suggested-readings-empty">
        <div className="suggested-readings-empty-text">
          <em>No suggested articles for this lecture</em>
        </div>
      </div>
    );
  }

  const showSuggestedReadingsTableHeader = () => (
    <div className="av-table-header suggested-readings-table-header">
      {showCheckbox && <div className="reading-checkbox-header"></div>}
      <div className="av-table-primary-header reading-article-header flex-fill">
        Article
      </div>
      <div className="reading-action-header">Actions</div>
    </div>
  );

  const renderSuggestedReadingRow = (article, isAccepted = false) => {
    const isSelected = selectedArticles.includes(article._id);
    return (
      <div
        key={article._id}
        className={classNames(
          'av-table-row reading-row suggested-reading-row',
          { 'is-selected': isSelected },
        )}
      >
        {showCheckbox && (
          <div className="reading-checkbox">
            {/* <Checkbox
              checked={isSelected}
              handleChange={() => onSelectArticle?.(article._id)}
              ariaLabel="Select article"
              labelClassName="pl-0"
              className="mb-0"
            /> */}
          </div>
        )}
        <div className="av-table-primary reading-article flex-fill">
          <TopicReadingArticle article={article} linkToUrl={true} />
        </div>
        <div className="reading-actions suggested-reading-actions">
          <button
            type="button"
            className={classNames('btn-icon btn-accept', {
              selected: acceptedReadings.includes(article._id),
            })}
            onClick={() => handleAccept(article._id)}
            title="Accept"
          >
            <Icon icon={ICONS.CHECK} size={16} />
          </button>
          <button
            type="button"
            className={classNames('btn-icon btn-reject', {
              selected: rejectedReadings.includes(article._id),
            })}
            onClick={() => handleReject(article._id)}
            title="Reject"
          >
            <Icon icon={ICONS.CLOSE} size={14} />
          </button>
        </div>
      </div>
    );
  };

  const showSuggestedReadingsTable = () => {
    return (
      <>
        {/* {acceptedList.map((reading) =>
          renderSuggestedReadingRow(reading, true),
        )}
        {acceptedList.length > 0 && pendingList.length > 0 && (
          <div className="suggested-readings-divider">
            <hr />
          </div>
        )}
        {pendingList.map((reading) =>
          renderSuggestedReadingRow(reading, false),
        )} */}

        {suggestedReadings.map((reading) =>
          renderSuggestedReadingRow(reading, reading.status === 'approved'),
        )}
      </>
    );
  };

  const renderBanner = () => (
    <div className="suggested-readings-banner">
      <div className="banner-content">
        <strong>Draft — only visible to you.</strong> Approve the articles you
        want, remove the rest, then publish to students.
        <br />
        <span className="banner-stats">
          {filteredSuggestedReadings.length} suggested ·{' '}
          {suggestedReadings.length} sources · {acceptedReadings.length}{' '}
          published in last 2 weeks
        </span>
      </div>
      <div className="banner-actions">
        <button type="button" className="btn-discard" onClick={handleDiscard}>
          Discard
        </button>
        <button
          type="button"
          className="btn-publish"
          onClick={handlePublish}
          disabled={!hasAcceptedReadings}
        >
          Publish to students
        </button>
      </div>
    </div>
  );

  return (
    <div className="av-table suggested-readings">
      {showTitle && (
        <div className="av-table-title">
          <span>Suggested Readings</span>
        </div>
      )}
      <div className="av-table-container suggested-readings-container">
        {showBanner && renderBanner()}
        {/* {showSuggestedReadingsTableHeader()} */}
        {showSuggestedReadingsTable()}
      </div>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  const selectedCourse = state.classRoom.selectedCourse || null;
  const selectedTopic = state.classRoom.selectedTopic || null;
  const course = state.classRoom.courses.find(
    (course) => course.courseId === selectedCourse,
  );
  const topic = course?.topics?.find((topic) => topic._id === selectedTopic);
  const syllabus = state.syllabus?.currentSyllabus?.syllabus;
  const syllabusRow =
    ownProps.syllabusRow ??
    syllabus?.rows?.find((row) => row.courseTopicId === selectedTopic);
  const suggestedReadings = syllabusRow?.readings ?? [];

  return {
    user: state.user,
    selectedCourse,
    selectedTopic,
    course,
    topic,
    syllabus,
    syllabusRow,
    suggestedReadings,
  };
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(Actions, dispatch);
  return {
    actions,
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopicSuggestedReadings);
